import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

type Props = {
  renderOutside: boolean;
  offsetFromTop?: boolean;
};

export const ConditionalPortal: React.FC<Props> = ({
  renderOutside,
  offsetFromTop = false,
  children,
}) => {
  const divRef = React.useRef(document.createElement('div'));

  React.useEffect(() => {
    document.body.appendChild(divRef.current);

    return () => {
      document.body.removeChild(divRef.current);
    };
  }, []);

  const classes = classNames('conditional-portal__outside', {
    'conditional-portal__offset': offsetFromTop,
  });

  return (
    <div className='conditional-portal'>
      {renderOutside
        ? ReactDOM.createPortal(<div className={classes}>{children}</div>, divRef.current)
        : children}
    </div>
  );
};
